export default __webpack_public_path__ + "assets/static/data/code-gen-data.0a79d85f81e8c300a8a722d72e8fa7bd.json";